//=======================================================================================================
//-------------------------------------------------------------------------------------------------------
//	Globals
//-------------------------------------------------------------------------------------------------------
//=======================================================================================================
var screen_width = (window.innerWidth > 0) ? window.innerWidth : screen.width;

var delay = 0;
var activePopup;
var posTop;
var posRight;
var posBottom;
var posLeft;
var number;

//=======================================================================================================
//-------------------------------------------------------------------------------------------------------
//	Window listeners
//-------------------------------------------------------------------------------------------------------
//=======================================================================================================
document.addEventListener("touchstart", function() {},false);

$(window).load( function() {
	InitResize(screen_width);
});

$(window).resize( function() {
	screen_width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
	InitResize(screen_width);
});

$(window).on("orientationchange",function(){
	InitResize(screen_width);
});

//=======================================================================================================
//-------------------------------------------------------------------------------------------------------
//	Custom Javascript onready
//-------------------------------------------------------------------------------------------------------
//=======================================================================================================
$(document).ready(function(){

//-------------------------------------------------------------------------------------------------------
//	Init the fullpage panel functionality
//-------------------------------------------------------------------------------------------------------
	$('#wrapper').fullpage({
        sectionSelector: '.panel-box',
        scrollingSpeed: 700,
        animateAnchor: false,
        recordHistory: false,
		scrollOverflow: true,
		scrollOverflowOptions: {
		    bounce: true,
			keyBindings: true,
		    mouseWheel: true,
		    momentum: true,
		    click: false
		},
		keyboardScrolling: false,
        onLeave: function(index, nextIndex, direction){
            
            var leavingSection = $(this);

            $('.intro-button-outer', leavingSection).animate({'bottom': '100%'},500);
            $('.mask', leavingSection).animate({'opacity': '0'},200, function(){
	            $('.panel-popup', leavingSection).fadeOut();
            });

        },
        afterResize: function(){
		//	location.reload();
        },
        afterLoad: function(anchorLink, index){
            
            var loadedSection = $(this);

            $('.intro-button-outer', loadedSection).animate({'bottom': '1%'},500);
            $('.mask', loadedSection).animate({'opacity': '0.6'},200, function(){
	            $('.panel-popup', loadedSection).fadeIn();
            });

            if (index == 2 )
            {
            	$.fn.fullpage.setAllowScrolling(false);
            	$('.spread-splash-dimm').fadeIn();
            	$('.spread-splash-outer').fadeIn();
            	$('.essay-more').show();

            }

            else if (index == 1 )
            {
            	$.fn.fullpage.setAllowScrolling(true);
            	$('.essay-more').hide();
            }

            else
            {
            	$.fn.fullpage.setAllowScrolling(false);
            	$('.essay-more').hide();
            }

            $('#menu a').css('font-weight', '300');
			$('#menu a.panel' + index).css('font-weight', '600');



        }
    });

	//	Next panel click listener
	$('.scroll-next').click(function(e){
		e.preventDefault();
		$.fn.fullpage.moveSectionDown();
	});

	$('.nav-prev').click(function(e){
		e.preventDefault();
		$.fn.fullpage.moveSectionUp();
	});

	$('.nav-next').click(function(e){
		e.preventDefault();
		$.fn.fullpage.moveSectionDown();
	});

//-------------------------------------------------------------------------------------------------------
//	Hotspot event listeners
//-------------------------------------------------------------------------------------------------------
	$('body').on('mouseleave', '#menu', function(){
		$('#menu').removeClass('active');
		$('#nav-toggle').removeClass('active');
	})

	$('body').on('mouseout', '.spread-hotspot', function () {
		hideMarginText();
		removeBlur();
	});

	$('body').on('mouseover', '.spread-hotspot', function (e) {
	    e.stopPropagation();
	 	showMarginText(this);
		addBlur(this);
	});

	$('body').on('click touch', '.spread-hotspot', function (e) {
	    e.stopPropagation();
	    e.preventDefault();
		showPopup(this);
	});



	$('body').on('click', '.overlay-close', function (e) {
	    e.stopPropagation();
		hidePopup();
	});

	$('body').on('click', '.spread-wrapper', function(e){
	 //    e.stopPropagation();
		// hidePopup();
	});

	$('body').on('click', '.jouele', function(){

		if ($(this).hasClass('jouele-status-playing')) {
			$(this).jouele("pause");
		} else {
			$(this).jouele("play");	
		}
	});

	$('body').on('click', '.spread-splash-dimm, .spread-splash-outer', function(){

		$('.spread-splash-dimm').fadeOut();
    	$('.spread-splash-outer').fadeOut();
    	$('.essay-more').fadeIn();
		hidePopup();
    	
    });

    setInterval( function(){
    	if ($.Jouele.lastPlayed) {

    		playerObj = $.Jouele.lastPlayed.$container[0];

    		if (!$(playerObj).parent().hasClass('now-playing')) {
	    		nowPlayingDesc = $('.jouele-control-text', $.Jouele.lastPlayed.$container[0]).text();
				$('#nav .jouele-control-text').text('Now Playing: ' + nowPlayingDesc );
    		}

    	}
    },1000)

//-------------------------------------------------------------------------------------------------------
//	Fancy menu animation
//-------------------------------------------------------------------------------------------------------
	document.querySelector( "#nav-toggle" )
		.addEventListener( "click", function() {
			this.classList.toggle( "active" );
			$('#menu').toggleClass( "active" );
	});

//-------------------------------------------------------------------------------------------------------
//	Fastclick - iOS single click behavior
//-------------------------------------------------------------------------------------------------------
	FastClick.attach(document.body);

//-------------------------------------------------------------------------------------------------------
//  Play on page load
//-------------------------------------------------------------------------------------------------------

    setTimeout( function(){
        $('.now-playing .jouele').jouele('play');
        console.log( $('.now-playing .jouele').jouele ) ;
    },1000);
});

//=======================================================================================================
//-------------------------------------------------------------------------------------------------------
//	Function: showMarginText()
//-------------------------------------------------------------------------------------------------------
//=======================================================================================================
function showMarginText( _this )
{
	text = $(_this).attr('data-margintext');
	popupNumber = $(_this).attr('data-popup');

	if (text)
	{
		text = text;
	
		posTop = $(_this)[0].style.top;

		if (posTop == '4%')
		{
			posTop = '10%';
		}

		if (popupNumber == 0)
		{
			posTop = '10%';
		}

		$('.margin-text').html( text );
		$('.margin-text').css( 'top', posTop );
		$('.margin-text').show();
	}

	text = $(_this).attr('data-margintextleft');

	if (text)
	{
		text = text;

		posTop = $(_this)[0].style.top;

		$('.margin-textleft').html( text );
		$('.margin-textleft').css( 'top', posTop );
		$('.margin-textleft').show();
	}
}

//=======================================================================================================
//-------------------------------------------------------------------------------------------------------
//	Function: showMarginText()
//-------------------------------------------------------------------------------------------------------
//=======================================================================================================
function hideMarginText()
{
	$('.margin-text').hide();
	$('.margin-textleft').hide();
}

//=======================================================================================================
//-------------------------------------------------------------------------------------------------------
//	Function: showMarginText()
//-------------------------------------------------------------------------------------------------------
//=======================================================================================================
function showPopup( _this )
{
	number = $(_this).attr('data-popup');
	screen_width = (window.innerWidth > 0) ? window.innerWidth : screen.width;

	if (number)
	{
		if (screen_width <= 480) 
		{
			var overlayContent = $('#overlay-' + number).html();
			$('.mobile-overlay').html( overlayContent );
			$('.mobile-overlay').fadeIn();
		}	

		else 
		{

			addBlur( _this );

			posTop = $(_this)[0].style.top;
			activePopup = number;

		//	$('.jouele').jouele('pause');
			$('.spread-overlay').hide();
			$('#overlay-' + number).fadeIn(100);

		}

    //	$('.spread-splash-dimm').fadeIn();

	}

	else
	{
		activePopup = null;
	}
}

//=======================================================================================================
//-------------------------------------------------------------------------------------------------------
//	Function: showMarginText()
//-------------------------------------------------------------------------------------------------------
//=======================================================================================================
function hidePopup()
{
	activePopup = null;

	removeBlur();

	$('img.spread-blur').removeClass('spread-blur-blurred');
	$('.spread-overlay').hide();
//	$('.jouele').jouele('pause');

	$('.spread-splash-dimm').fadeOut();
    $('.spread-splash-outer').fadeOut();

    $('.mobile-overlay').fadeOut();

    	
}

//=======================================================================================================
//-------------------------------------------------------------------------------------------------------
//	Function: showMarginText()
//-------------------------------------------------------------------------------------------------------
//=======================================================================================================
function removeBlur()
{
	if (activePopup) {
		return;
	}

	$('img.spread-foreground').attr('src', 'assets/img/spread7.jpg');

	//$('img.spread-blur').removeClass('spread-blur-blurred');

	// if (!activePopup) 
	// {
	// 	hidePopup();
	// }
}

//=======================================================================================================
//-------------------------------------------------------------------------------------------------------
//	Function: showMarginText()
//-------------------------------------------------------------------------------------------------------
//=======================================================================================================
function addBlur(_this)
{
	number = $(_this).attr('data-popup');
	noblur = $(_this).attr('data-noblur');
	blurimage = $(_this).attr('data-blurimage');


	if (number)
	{
		posTop = $(_this)[0].style.top;
		posRight = $(_this)[0].style.right;
		posBottom = $(_this)[0].style.bottom;
		posLeft = $(_this)[0].style.left;

		if (!noblur && blurimage) {

			$('img.spread-foreground').attr('src', blurimage);
		}
	}

	else
	{
		if (!noblur) {		
			$('img.spread-foreground').attr('src', 'assets/img/spread5.jpg');
	
		}
	}
}

//=======================================================================================================
//-------------------------------------------------------------------------------------------------------
//	Function: showMarginText()
//-------------------------------------------------------------------------------------------------------
//=======================================================================================================
function InitResize(){
	
	screen_width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
	
	var introArrow = $('.intro-button-outer');

	hidePopup();
	hideMarginText();
	removeBlur();

	if (screen_width < 500)
	{
		$('.spread-wrapper').css('width', screen_width + 100 );
		$('.spread').css('height', 'auto');
		$('.spread-foreground').css('height', 'auto');
		$('.spread-wrapper').css('height', $('.spread-foreground').height() );
		return;
	}

	// else if (screen_width < 1113)
	// {
	// 	$('.spread').css('height', 'auto');
	// 	$('.spread-foreground').css('height', 'auto');
	// 	$('.spread-wrapper').css('height', $('.spread-foreground').height() );


	// }

	if ($('.spread-foreground').width() > 0) 
	{
		$('.spread-wrapper').css('width', $('.spread-foreground').outerWidth());
		// $('.spread-inner').css('width', $('.spread-foreground').outerWidth());
		// $('.spread-inner').css('overflow', 'hidden');
		// $('.spread-inner').css('margin', '0 auto');
	}


	//if (screen_width > 1112)
	//{

		$('.spread').css('height', $(window).height() - 77);
		$('.spread-foreground').css('height', '100%');
		$('.spread-wrapper').css('height', '100%' );

	//}	

//	$('.scroll-container').css('height', $(window).height() - 77);
}

//=======================================================================================================
//-------------------------------------------------------------------------------------------------------
//	Function: ResizeDone()
//-------------------------------------------------------------------------------------------------------
//=======================================================================================================
function ResizeDone(){
	if ($('.spread-background').width() > 0) {
		$('.spread-wrapper').css('width', $('.spread-background').width());
	}
}


//=======================================================================================================
//-------------------------------------------------------------------------------------------------------
//	Function: OnScroll()
//-------------------------------------------------------------------------------------------------------
//=======================================================================================================
function OnScroll(){
	
}